import * as React from "react";
import PasswordForm from "../forms/passwordForm";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import { IPasswordFormProps } from "../forms/passwordForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface IPasswordScreenProps extends IPasswordFormProps {
  onClose?: () => void;
  securityImgObj: any;
}

const PasswordWithApi: React.FC<IPasswordScreenProps> = (props) => {
  return (
    <div className="loginWithApi">
      <div className="loginWithApi_container">
        <div className="loginWithApi_head">
          <span>
            <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
          </span>
          <span>
            <i className="edel-icon-close" onClick={props.onClose}></i>
          </span>
        </div>

        <div className="loginWithApi_contant">
          <div className="loginWithApi_appInfo">
            <img
              src={
                props.securityImgObj.logo
                  ? appUrl.appIcon + props.securityImgObj.logo
                  : DefaultAppIcon
              }
              alt="app logo"
            />
            <h3>{props.securityImgObj.appNm}</h3>
          </div>
          <PasswordForm {...props} autoFocus={true} />
        </div>
      </div>
    </div>
  );
};

export default PasswordWithApi;
